export var ADD_AUDIO = 'GAME_ADD_AUDIO'
export var PLAY_AUDIO = 'GAME_PLAY_AUDIO'
export var PLAY_HOWL_AUDIO = 'GAME_PLAY_HOWL_AUDIO'
export var PLAY_BACKGROUND = 'GAME_PLAY_BACKGROUND'
export const REMOVE_AUDIO = 'GAME_REMOVE_AUDIO'
export const DISABLE_AUDIO = 'GAME_DISABLE_AUDIO'
export const REMOVE_HOWL_AUDIO = 'GAME_REMOVE_HOWL_AUDIO'
export const PAUSE_AUDIO = 'GAME_PAUSE_AUDIO'
export const RESUME_AUDIO = 'GAME_RESUME_AUDIO'
export const REGISTER_AUDIO_PLAYING = 'GAME_REGISTER_AUDIO_PLAYING'

export const playAudio = (audioId) => {
  return { type: PLAY_AUDIO, data: audioId }
}
export const playHowlAudio = (audioId) => {
  return { type: PLAY_HOWL_AUDIO, data: audioId }
}
export const playBackground = (audioId) => {
  return { type: PLAY_BACKGROUND, data: audioId }
}
export const addAudio = (audioId) => {
  return { type: ADD_AUDIO, data: audioId }
}
export const removeAudio = (audioId) => {
  return { type: REMOVE_AUDIO, data: audioId }
}
export const disableAudio = (bool) => {
  return { type: DISABLE_AUDIO, data: bool }
}
export const removeHowlAudio = (audioId) => {
  return { type: REMOVE_HOWL_AUDIO, data: audioId }
}
export const pauseAudio = (audioId) => {
  return { type: PAUSE_AUDIO, data: audioId }
}
export const resumeAudio = (audioId) => {
  return { type: RESUME_AUDIO, data: audioId }
}
export const registerAudioPlaying = (audio) => {
  return { type: REGISTER_AUDIO_PLAYING, data: audio }
}
